import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "imageType", "orientation", "style", "prompt", "modified"
  ]
  
  connect() {
    console.log("Image prompt controller connected")
    
    // Set initial values
    if (this.hasImageTypeTarget && this.hasOrientationTarget) {
      this.updateImagePromptAndOrientation()
    }
  }
  
  // Update the prompt and orientation when image type changes
  updateImagePromptAndOrientation() {
    if (!this.hasImageTypeTarget || !this.hasOrientationTarget || !this.hasPromptTarget) return
    
    // Get the selected option
    const selectedOption = this.imageTypeTarget.options[this.imageTypeTarget.selectedIndex]
    
    // Only update prompt if it hasn't been modified by the user
    if (this.hasModifiedTarget && this.modifiedTarget.value === "false") {
      const imagePrompt = selectedOption.getAttribute('data-image-prompt')
      if (imagePrompt) {
        this.promptTarget.value = imagePrompt
      }
    }
    
    // Update orientation
    const orientation = selectedOption.getAttribute('data-orientation')
    if (orientation) {
      // Find and select the matching orientation option
      for (let i = 0; i < this.orientationTarget.options.length; i++) {
        if (this.orientationTarget.options[i].value === orientation) {
          this.orientationTarget.selectedIndex = i
          break
        }
      }
    }
  }
  
  // Update the prompt when style changes
  updatePromptForStyle() {
    if (!this.hasStyleTarget || !this.hasPromptTarget) return
    
    // Get the selected option
    const selectedOption = this.styleTarget.options[this.styleTarget.selectedIndex]
    
    // Only update prompt if it hasn't been modified by the user
    if (this.hasModifiedTarget && this.modifiedTarget.value === "false") {
      const imagePrompt = selectedOption.getAttribute('data-image-prompt')
      if (imagePrompt) {
        this.promptTarget.value = imagePrompt
      }
    }
  }
  
  // Mark prompt as modified when user edits it
  setPromptModified() {
    if (this.hasModifiedTarget) {
      this.modifiedTarget.value = "true"
    }
  }
}